import React, { useMemo, useEffect } from 'react';
import { isEmpty, isArray } from 'lodash';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { NotableClientData } from '../../../services/getNotableClients';
import { useMonitoring } from '../../../monitoring';
import { NotableClients } from './NotableClients';
import { AddNotableClientsBlock } from './AddNotableClientsBlock';
import { NotableClientsProps } from './types';

const invokeClients = (notableClients: NotableClientData[]) =>
    isArray(notableClients) ? notableClients.filter((el) => !isEmpty(el)) : notableClients;

export const NotableClientsResolver: React.FC<NotableClientsProps> = (props) => {
    const { fireEvents, Providers } = useMonitoring();
    const { notableClients, isCurrentUser, isEligibleSeller, username } = useFreelancerPageContext();
    const hasClients = useMemo(() => !isEmpty(invokeClients(notableClients)), [notableClients]);

    useEffect(() => {
        if (hasClients) {
            fireEvents({
                [Providers.Mixpanel]: {
                    type: 'Notable client exist',
                },
            });
        }
    }, [Providers.Mixpanel, fireEvents, hasClients]);

    if (hasClients) {
        return <NotableClients {...props} />;
    }

    if (!hasClients && isCurrentUser && isEligibleSeller) {
        return <AddNotableClientsBlock username={username} />;
    }

    return null;
};

export default NotableClientsResolver;
